import React from 'react';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import ButtonBase from '@material-ui/core/ButtonBase';
import IconButton from '@material-ui/core/IconButton';
import CheckBox from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlank from '@material-ui/icons/CheckBoxOutlineBlank';
import intl from 'react-intl-universal';
import CurrencyFormat from 'react-currency-format';
import { BarChart, Bar, XAxis, YAxis, Tooltip } from 'recharts';

class WhatIfPres extends React.Component {
  render() {
    const {
      result,
      cardHeader,
      cardFooter,
      barSeriesConfig,
      // onMouseOver,
      // onMouseLeave,
      // hoveredSeries,
      barSeriesData,
      maxCompensation,
      onClick,
    } = this.props;

    return (
      <div>
        <div className="whatif-result-card whatif-result-card-line">
          <CardHeader
            classes={{ title: 'whatif-result-card-header-title', root: 'whatif-result-card-header-root' }}
            action={[
              <IconButton onClick={this.props.onUncheck} style={{ display: result.selected ? '' : 'none' }}>
                <CheckBox />
              </IconButton>,
              <IconButton onClick={this.props.onCheck} style={{ display: result.selected ? 'none' : '' }}>
                <CheckBoxOutlineBlank />
              </IconButton>,
              // <IconButton onClick={this.props.onCancel}>
              //   <Clear />
              // </IconButton>,
            ]}
            title={cardHeader}
            borderBottom={1}
          />
          <ButtonBase style={{ display: 'block', textAlign: 'initial' }} onClick={onClick}>
            <CardContent className="whatif-results-card">
              <div className="header-field-grid">
                <div className="header-field travel-scenario nohover">
                  <label className="field-label">{result.misc.headerLabel}</label>
                  <span className="field-text">{result.misc.headerText}</span>
                </div>
              </div>
              <BarChart data={barSeriesData} width={232} height={250} margin={{ left: -24, right: 0, top: 20, bottom: 30 }}>
                <XAxis hide={true} dataKey="name" />
                <YAxis hide={true} type="number" domain={[0, maxCompensation]} />
                <Tooltip
                  cursor={false}
                  formatter={(value, name, props) => {
                    return [
                      <CurrencyFormat
                        value={value}
                        displayType={'text'}
                        decimalScale={2}
                        thousandSeparator={true}
                        prefix={intl.get('whatif.calculator.currency.prefix')[result.outputCurrency]}
                        suffix={intl.get('whatif.calculator.currency.suffix')[result.outputCurrency]}
                      />,
                      name,
                      props,
                    ];
                  }}
                  isAnimationActive={false}
                />
                <Bar stackId="x" id={0} dataKey="Taxes" fill={barSeriesConfig.taxes.color} />
                <Bar stackId="x" id={3} dataKey="Assignment Allowances" fill={barSeriesConfig.assignmentAllowances.color} />
                <Bar stackId="x" id={1} dataKey="Relocation Costs" fill={barSeriesConfig.relocationCosts.color} />
                <Bar stackId="x" id={2} dataKey="Base Compensation" fill={barSeriesConfig.baseCompensation.color} />
                />
              </BarChart>

              <div className="whatif-result-card-amount">{cardFooter}</div>
              <div className="whatif-result-card-time">for {result.duration}</div>
            </CardContent>
          </ButtonBase>

          <div className="whatif-result-card-view-button" onClick={onClick}>
            View Details
          </div>
        </div>
      </div>
    );
  }
}

export default WhatIfPres;
